var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { name: "step4" } },
    [
      _c("StepBox", { attrs: { step: _vm.step, exam: _vm.exam } }),
      _vm._v(" "),
      _c("div", { staticClass: "tab-box" }, [
        _vm.getExam.frontMonitoring || _vm.getExam.faceEvent
          ? _c(
              "span",
              { staticClass: "item-1", class: { active: _vm.isWebcamPhase } },
              [
                _c("div", { staticClass: "inner" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("preRegistration.step4.front.title"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("preRegistration.step4.front.type"))),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.getExam.sideMonitoring
          ? _c(
              "span",
              { staticClass: "item-2", class: { active: _vm.isMobilePhase } },
              [
                _c("div", { staticClass: "inner" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("preRegistration.step4.side.title"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("preRegistration.step4.side.type"))),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.getExam.screenMonitoring
          ? _c(
              "span",
              { staticClass: "item-3", class: { active: _vm.isScreenPhase } },
              [
                _c("div", { staticClass: "inner" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("preRegistration.step4.screen.title"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("preRegistration.step4.screen.type"))),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("Front", {
        attrs: {
          userId: _vm.userInfo.id,
          roomId: _vm.periodInfo.videoRoomId,
          phase: _vm.phase,
          active: _vm.webcamIsRunning,
          done: _vm.connectChecked["webcam"],
          frontMonitoring: _vm.getExam.frontMonitoring,
          faceEvent: _vm.getExam.faceEvent,
        },
        on: {
          connectStatusChanged: _vm.connectStatusChanged,
          changeFrontActive: _vm.changeFrontActive,
        },
      }),
      _vm._v(" "),
      _c("Mobile", {
        attrs: {
          userId: _vm.userInfo.id,
          roomId: _vm.periodInfo.videoRoomId,
          phase: _vm.phase,
          active: _vm.mobileIsRunning,
          done: _vm.connectChecked["mobile"],
          sideMonitoring: _vm.getExam.sideMonitoring,
        },
        on: {
          connectStatusChanged: _vm.connectStatusChanged,
          changeMobileActive: _vm.changeMobileActive,
        },
      }),
      _vm._v(" "),
      _c("Screen", {
        attrs: {
          userId: _vm.userInfo.id,
          roomId: _vm.periodInfo.videoRoomId,
          phase: _vm.phase,
          active: _vm.screenIsRunning,
          done: _vm.connectChecked["screen"],
          screenMonitoring: _vm.getExam.screenMonitoring,
        },
        on: {
          connectStatusChanged: _vm.connectStatusChanged,
          changeScreenActive: _vm.changeScreenActive,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "btn-box step" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-line-dark btn-lg icon icon-arrow_prev left",
              attrs: {
                type: "button",
                disabled: _vm.isPreviousDisabled,
                name: "go-back-step-3",
              },
              on: { click: _vm.previous },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("preRegistration.common.previousStep")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col ml-auto" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-line-dark btn-lg icon icon-arrow_next",
              attrs: {
                type: "button",
                disabled: _vm.isNextDisabled,
                name:
                  _vm.phase === 1
                    ? _vm.labelButton
                    : `go-to-${_vm.phase}-check`,
              },
              on: {
                click: function ($event) {
                  return _vm.onNext(_vm.phase)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.labelButton) + "\n      ")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }